import { gsap } from '@gsap/shockingly';
import { ScrollTrigger } from '@gsap/shockingly/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const globalAnimation = {
	ui: {},

	init: function() {
		this.bindUI();
		this.bindAnim();
		this.bindEvents();
	},

	bindUI: function() {
		this.ui.$anim_number = document.querySelectorAll('.js-anim-number');
		this.ui.$anim_graphBar = document.querySelectorAll('.js-anim-graphBar');
		this.ui.$anim_title = document.querySelectorAll('.js-anim-title');
	},

	bindAnim: function() {
		this.ui.$anim_number.forEach($anim_number => {
			if(!isNaN(parseInt($anim_number.innerHTML))){
				gsap.from($anim_number, {
					scrollTrigger: $anim_number,
					textContent: 0,
					duration: 1,
					snap: { textContent: 1 },
					stagger: 0.25,
					ease: "power4.out"
				});
			}
		});

		this.ui.$anim_title.forEach(anim_title => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: anim_title,
					start: 'top+=5% bottom',
				}
			})

			let anim_title_text = anim_title.querySelector('span');

			timeline
				.from(anim_title, {
					'--before-width': 0,
					duration: 0.8,
					ease: "power3.out"
				})
				.from(anim_title_text, {
					x: -20,
					autoAlpha: 0,
					duration: 0.8,
					ease: "circ.out"
				}, '<0.25')
		});


		let mm = gsap.matchMedia();
		mm.add("(min-width: 769px)", () => {
			ScrollTrigger.batch('.js-anim-graphBar', {
				start: 'bottom bottom-=1%',
				once: true,
				onEnter: (anim_graphBar, triggers) => {
					gsap.to(anim_graphBar, {
						height: '100%',
						duration: 1,
						stagger: 0.4,
						ease: "power1.inOut"
					});
					anim_graphBar.forEach((elem, i) => {
						let anim_graphBar_number = elem.querySelector('.js-anim-graphBar-number');
						if (anim_graphBar_number !== null) {
							gsap.from(anim_graphBar_number, {
								delay: i * 0.4 + 0.1,
								textContent: 0,
								duration: 1,
								snap: { textContent: 1 },
								stagger: 0.4,
								ease: "power4.out"
							});
						}
					});
				}
			});
		});

		mm.add("(max-width: 768px)", () => {
			ScrollTrigger.batch('.js-anim-graphBar-number', {
				start: 'bottom bottom-=1%',
				once: true,
				onEnter: (anim_graphBar_number, triggers) => {
					gsap.from(anim_graphBar_number, {
						textContent: 0,
						duration: 1,
						snap: { textContent: 1 },
						stagger: 0.4,
						ease: "power4.out"
					});
				}
			});
		});
	},

	bindEvents: function() {

	},
};

export default globalAnimation;
